import { BulletinDetailsTabs } from "entities/bulletin/types";
import React, { FC, SyntheticEvent, useEffect } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { useBulletinDetails } from "../../context";
import { StyledTab, StyledTabs } from "./styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = useBulletinDetails();
  const { allowed: hasReadAccess } = useRolePermission("bulletinBoard:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission("bulletinBoard:translations:read");

  const shouldRenderGeneralTab = hasReadAccess;
  const shouldRenderTranslationsTab = hasReadAccess || hasReadTranslationsAccess;

  const handleTabChange = (_: SyntheticEvent, newTab: BulletinDetailsTabs) => {
    setSelectedTab(newTab);
  };

  useEffect(() => {
    return () => {
      setSelectedTab(BulletinDetailsTabs.General);
    };
  }, [setSelectedTab]);

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="page-tab-general"
          aria-controls="module-tabpanel-general"
          value={BulletinDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="page-tab-translations"
          aria-controls="module-tabpanel-translations"
          value={BulletinDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
